module.exports = __webpack_public_path__ + "img/account-grey.50ce84fc.svg";